import messages from '@/i18n';

const SUPPORTED_LOCALES = ['en', 'fr', 'es', 'de'];
const DEFAULT_LOCALE = 'en';
const locale = SUPPORTED_LOCALES.includes(navigator.language) ? navigator.language : DEFAULT_LOCALE;
export default {
  locale,
  messages
};
